import {useNavigate} from 'react-router';
import {observer} from 'mobx-react-lite';
import {useStoreContext} from '@store/store-context';
import {CreateGoalForm} from '../../../create-goal/create-goal-form';
import {EditGoalOverlay, EditGoalSidePanel} from './manager-edit-goal.styles';

export const ManagerEditGoal = observer(() => {
  const {
    goalsState: {isManagerEditing, setEditing, setIsManagerEditing},
  } = useStoreContext();
  const navigate = useNavigate();

  const handleCloseDrawer = (e: any) => {
    e.preventDefault();
    setIsManagerEditing(false);
    setEditing(false);
    navigate(-1);
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
  };

  if (!isManagerEditing) {
    return null;
  }

  return (
    <>
      <EditGoalOverlay onClick={handleCloseDrawer} />
      <EditGoalSidePanel role="dialog" aria-modal="true" aria-label="Edit goal">
        <CreateGoalForm
          onSubmit={onSubmit}
          editheaderShow={true}
          handleCloseDrawer={handleCloseDrawer}
        />
      </EditGoalSidePanel>
    </>
  );
});
